import { render, staticRenderFns } from "./StorySettings.vue?vue&type=template&id=3cd5caf3&scoped=true"
import script from "./StorySettings.vue?vue&type=script&lang=js"
export * from "./StorySettings.vue?vue&type=script&lang=js"
import style0 from "./StorySettings.vue?vue&type=style&index=0&id=3cd5caf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5caf3",
  null
  
)

export default component.exports